import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ensureLinkPrefix',
    standalone: false
})
export class EnsureLinkPrefixPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value.startsWith('http')) {
      return value;
    }

    return 'http://' + value;
  }

}
